module.exports = __webpack_public_path__ + "img/dp-gr-ly4.8a151dc8.png";